import { useForm } from "react-hook-form";
import InfoOldContractComponent from "../../components/info-perso-template/InfoOldContractComponent";
import StickButtonsBloc from "../common/StickButtonsBloc";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { useEffect, useState } from "react";
import { IOldCompetitor } from "../../context/model";
import useAppState from "../../context/AppContext";
import { getConcurrents } from "../../services/CustomerApiService";
import { APP_URLS, ERROR_MESSAGES } from "../../const/AppConst";
import { useNavigate } from "react-router-dom";
import { accessJsonAttr, getListOldContracts } from "../../utils/utils";
import MgpFormRadio from "../../elements/MgpFormRadio/MgpFormRadio";


export type InfoOldContractBlocFormData = {
    name: string,
    address: string,
    isOtherName: boolean,
    contractNumbers: string,
    buildingName: string,
    city: string,
    postalCode: string,
    otherName?: string,
    additionalAddress?: string,
    hasOldMutual: string | null,
    hasMgpInsurance?: string | null,
}


export default function InfoOldContractBloc() {

    const {
        state: { proposition, updatedProposition, jwtToken, additionalData, isRetired },
        dispatch,
    } = useAppState();

    const navigate = useNavigate();

    const [concurrents, setConcurrents]= useState<IOldCompetitor[]>([]);
    
    useEffect(()=> {
        const fetchConcurrents: any = async () => {
            const  res= await getConcurrents(jwtToken!.accessToken);
            setConcurrents(res.data);
        };

        fetchConcurrents();

    }, []);

    const CONTRACT_CURRENT_NOMENCLATURES = getListOldContracts(concurrents);

    const validationSchema = Yup.object().shape({
        hasOldMutual: Yup.string().oneOf(['true', 'false']).required(ERROR_MESSAGES.requiredMsg),
        hasMgpInsurance: Yup.string()
            .when('hasOldMutual', {
                is:'true',
                then: Yup.string().oneOf(['true', 'false']).required(ERROR_MESSAGES.requiredMsg),
                otherwise: Yup.string().notRequired().nullable()
            }),
        name: Yup.string()
            .when(['hasOldMutual', 'isOtherName', 'hasMgpInsurance'], {
                is: (hasOldMutual : string, isOtherName : boolean, hasMgpInsurance : string) => hasOldMutual === 'true' && isOtherName === false && hasMgpInsurance === 'false',
                then: Yup.string().required(ERROR_MESSAGES.requiredMsg),
            }),
        contractNumbers: Yup.string()
            .when(['hasOldMutual', 'hasMgpInsurance', 'isOtherName'], {
                is: (hasOldMutual : string, hasMgpInsurance : string, isOtherName : boolean) => hasOldMutual === 'true' &&  hasMgpInsurance === 'false' && isOtherName === false,
                then: Yup.string().required(ERROR_MESSAGES.requiredMsg)
            }),
    });

    const {
        register,
        handleSubmit,
        watch,
        setValue, clearErrors,
        formState: { errors },
    } = useForm<InfoOldContractBlocFormData>({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            hasOldMutual: updatedProposition?.hasOldMutual !== null ? updatedProposition?.hasOldMutual?.toString() : null,
            name: updatedProposition?.oldCompetitor?.code ?? '',
            otherName: updatedProposition?.oldCompetitor?.otherName ?? '',
            address: updatedProposition?.oldCompetitor?.address ?? '',
            buildingName: updatedProposition?.oldCompetitor?.buildingName ?? '',
            contractNumbers: updatedProposition?.oldCompetitor?.contractNumbers?.join(', ') ?? '',
            isOtherName: updatedProposition?.oldCompetitor?.isOtherName ?? false ,
            city: updatedProposition?.oldCompetitor?.city ?? '',
            postalCode: updatedProposition?.oldCompetitor?.postalCode ?? '',
            hasMgpInsurance: updatedProposition?.hasOldMutual === false ? null : updatedProposition?.hasMgpInsurance?.toString()
        },
        resolver: yupResolver(validationSchema),
    });

    const hasOldMutual = watch("hasOldMutual");
    const hasMgpInsurance = watch("hasMgpInsurance");
    const resetValue = () => {
        setValue('contractNumbers', '');
        setValue('otherName', '');
        setValue('buildingName', '');
        setValue("address",'');
        setValue("postalCode", '');
        setValue("city", '');
        setValue('name', '');
        setValue("isOtherName", false);
        setValue("additionalAddress", '');
    };

    useEffect(()=> {
        if (hasOldMutual === 'false') {
            resetValue();
            setValue("hasMgpInsurance", null);
            clearErrors(['hasMgpInsurance', 'name','contractNumbers', "otherName", "additionalAddress", 'buildingName', 'address', "postalCode", "city", "isOtherName"]);
        } else if (hasOldMutual === 'true' && hasMgpInsurance === 'true') {
            resetValue();
            clearErrors(['name','contractNumbers', "otherName", "additionalAddress", 'buildingName', 'address', "postalCode", "city", "isOtherName"]);
        }
     
    }, [hasOldMutual, hasMgpInsurance, clearErrors]);

    const onNextAction = async (data: InfoOldContractBlocFormData) => {
        let tempUpdatedPropo = updatedProposition;
        if(tempUpdatedPropo) {
            tempUpdatedPropo.hasOldMutual = data?.hasOldMutual === 'true';
            tempUpdatedPropo.hasMgpInsurance = data?.hasMgpInsurance === "true";

            if(data?.hasOldMutual === 'false'){
                tempUpdatedPropo.oldCompetitor = {};
                tempUpdatedPropo.hasMgpInsurance = false;
            } 

            if(data?.hasOldMutual === 'true' && data?.hasMgpInsurance === "false") {
                
                if(!data.isOtherName) {
                    let result = concurrents.find(el => el?.code === data.name);
                    tempUpdatedPropo.oldCompetitor = {...result,
                        isOtherName: data.isOtherName,
                        contractNumbers: data.contractNumbers.split(',').map(el => el.trim()), 
                    }
                } else {
                    tempUpdatedPropo.oldCompetitor = {
                        name: data?.otherName,
                        address: data?.address,
                        isOtherName: data?.isOtherName,
                        buildingName: data?.buildingName,
                        city: data?.city,
                        postalCode: data?.postalCode,
                        otherName: data?.otherName,
                        contractNumbers: data.contractNumbers.split(',').map(el => el.trim()), 
                        code: "",
                    }
                }
                
            }

            if(data?.hasOldMutual === 'true' && data?.hasMgpInsurance === "true") {
                tempUpdatedPropo.oldCompetitor = {};
            }
        };
        
        dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.recapPage, updatedProposition: tempUpdatedPropo});
        navigate({
            pathname: APP_URLS.recapPage,
            search: `?id=${proposition!.propositionId}`,
        }); 
    };
    const onPreviousAction = async () => {
        let backUrl = APP_URLS.infoPersoRecapPage;
        if(proposition?.configuration.hasOfferStep) {
            backUrl = APP_URLS.guarantyPage;
        } else if(proposition?.configuration.canBeAddedBeneficiaries){
            if(additionalData?.hasChild || additionalData?.hasPartner) {
                backUrl = APP_URLS.familyDocumentsPage;
            } else {
                backUrl = APP_URLS.infoBeneficiaryStep0Page;
            }
        }
       
        dispatch({type: 'BACK_INFO_STEP', path: backUrl});
        navigate({
            pathname: backUrl,
            search: `?id=${proposition!.propositionId}`,
        });         
    }

    return (
        <form style={{width: '100%'}} className='bg-blanc shadow-noir p-lg mw-100 page-content'>

            <p className="text">Si vous avez souscrit depuis plus d'un an à une complémentaire santé, vous avez la possibilité de résilier celle-ci à tout moment sans motif. <span className='fushia'>(*)</span></p>

            <p className="text mt-sm">Je mandate la MGP pour effectuer les formalités de résiliation en mon nom, conformément à l'article L.221-10-2 du Code de la mutualité.</p>  
            
            <div className="groupRadio mt-sm">
                <div>
                    <MgpFormRadio id="hasOldMutual" value='true' label='Oui' register={register} errors={errors} />
                </div>
                <div>
                    <MgpFormRadio id="hasOldMutual" value='false' label='Non' register={register} errors={errors} />
                </div>  
            </div>

            {hasOldMutual === 'true' &&
                <div>
                    <p className="text mt-sm">J'ai un contrat santé à la MGP <span className='fushia'>(*)</span></p>
                    <div className="groupRadio mt-sm">
                        <div>
                            <MgpFormRadio id="hasMgpInsurance" value='true' label='Oui' register={register} errors={errors} />
                        </div>
                        <div>
                            <MgpFormRadio id="hasMgpInsurance" value='false' label='Non' register={register} errors={errors} />
                        </div>  
                    </div>

                     {hasMgpInsurance === 'false' &&
                        <InfoOldContractComponent 
                            register={register} 
                            errors={errors} 
                            watch={watch} 
                            setValue={setValue}
                            concurrentOptions={CONTRACT_CURRENT_NOMENCLATURES}
                            isRetired={isRetired}
                        />
                    }

                    {hasMgpInsurance === 'true' && 
                        <div>
                            <p className="text mt-sm">La MGP prend en charge la résiliation de votre contrat actuel à J-1 de la date d'effet de votre affiliation au contrat collectif de votre employeur.</p>
                        </div>
                    }

                            
                </div>
            }

            {hasOldMutual === 'false' &&
                <div className="mt-md">
                    <p className="text">Vous pouvez utilisez notre générateur de lettre de résiliation personnalisée pour un changement en toute simplicité en cliquant sur le lien suivant : <a className="link button-bloc" href={process.env.REACT_APP_MINI_SITE_RIA} target="_blank">cliquez ici</a></p>
                </div>
            }

           
            <div className='form-row pb-xl'>
                {(accessJsonAttr(errors, 'hasOldMutual') || accessJsonAttr(errors, 'hasMgpInsurance')) && (
                    <p className="error fushia m-y-xs">Veuillez choisir au moins une case</p>
                )}
            </div>

            <div className="pb-xl"></div>
            <div className="pt-xl">
                <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
            </div>

            <StickButtonsBloc 
                showPreviousButton={true} 
                disabledPreviousButton={false} 
                nextAction={handleSubmit(onNextAction)} 
                showNextButton={true} 
                previousAction={onPreviousAction}
            />

        </form>
      )
}